
export default function AppFeaturesSection() {
  const features = [
    {
      title: 'Asistente de inicio',
      description: 'Los puntos importantes del evento y de cómo funciona la APP descargada.',
      icon: 'ri-information-line'
    },
    {
      title: 'Mapa',
      description: 'Visualiza en los mapas de la APP los puntos de interés (ubicación del Campamento Real, punto de partida de los autobúses, zonas de parking, rutas para caminantes) y las zonas gastro (los restaurantes en donde podrás reservar para comer el después del evento).',
      icon: 'ri-map-pin-line'
    },
    {
      title: 'Mi Perfil',
      description: 'Consulta los detalles de tu registro para saber si el donativo está completado. Si has resultado ganador@ del sorteo, podrás consultar el estado del donativo de los accesos y tener visibilidad de ellos. Los podrás descargar en PDF, añadir al Wallet de tu terminal o visualizar el QR.',
      icon: 'ri-user-line'
    },
    {
      title: 'Registro',
      description: 'Formulario de registro en donde deberás facilitarnos tus datos para poder participar en el sorteo. Recuerda completar el donativo de registro por cada uno de los accesos solicitados.',
      icon: 'ri-user-add-line'
    },
    {
      title: 'Sorteo',
      description: 'Podrás consultar si has sido un@ de l@s afortunad@s en el sorteo. Después debes completar el donativo por los accesos solicitados.',
      icon: 'ri-gift-line'
    },
    {
      title: 'Bases del sorteo',
      description: 'Tendrás acceso a las bases del sorteo en gran parte de las secciones de la aplicación.',
      icon: 'ri-file-text-line'
    }
  ];

  return (
    <section id="app-oficial" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">APP oficial para acceder al Campamento Real</h1>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Las plataformas de registro publicadas facilitarán a pequeños y mayores, la participación en el sorteo 
            de los accesos al evento Campamento Real que se celebra todos los 5 de enero en Alcoy (Alicante - España).
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-center">
          <div className="space-y-8">
            {features.slice(0, 3).map((feature, index) => (
              <div key={index} className="text-center lg:text-right">
                <div className="flex justify-center lg:justify-end mb-4">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                    <i className={`${feature.icon} text-2xl text-red-600`}></i>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="flex justify-center">
            <img 
              src="https://static.readdy.ai/image/40f88d0dea4cb4de19f5f0c481deadea/acc17e5ecfe5b6b396325ed4ef994861.png" 
              alt="Secciones de la APP" 
              className="w-full max-w-md h-auto"
            />
          </div>

          <div className="space-y-8">
            {features.slice(3, 6).map((feature, index) => (
              <div key={index} className="text-center lg:text-left">
                <div className="flex justify-center lg:justify-start mb-4">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                    <i className={`${feature.icon} text-2xl text-red-600`}></i>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
